export enum ViewMode {
  Day = 'D',
  Week = 'W',
  Month = 'M',
}

export enum PageView {
  Calendar = 'calendar',
  Grid = 'grid',
}

export type DailyFilter = 'office' | 'outOfOffice' | 'workingElsewhere' | null;

export const DEFAULT_DAILY_FILTER: DailyFilter = null;
